export default {
  namespaced: true,
  state: {
    defaults: {},
  },
  mutations: {
    SET_DEFAULTS(state, defaults) {
      state.defaults = defaults;
    },
  },
  getters: {
    GET_DEFAULTS: (state) => state.defaults || {},
  },
};
